import { useDispatch } from 'react-redux';
import { registerChangeTimestamp } from '~/domain/roboticmower-details/store/mowerSitemapSyncStatus/reducer';
import { WebCommandEnum } from '../models/commands';
import { useConsumeWebCommand } from './use-consume-web-command';

const useMowerSitemapUpdate = () => {
  const dispatch = useDispatch();
  useConsumeWebCommand(WebCommandEnum.RoboticMowerSitemapUpdated, (command) => {
    if (command.params?.assetId !== undefined && command.params?.timestamp) {
      dispatch(registerChangeTimestamp(command.params));
    }
  });
};

export { useMowerSitemapUpdate };
